import React, { useEffect, useState } from "react";
import {
    Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid,
    MenuItem, IconButton, FormGroup, FormControlLabel, Checkbox, Tab, Tabs
} from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useEditActionTrackerMutation } from "store/slices/apis/actionTrackerSlice";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { RxCross2 } from "react-icons/rx";
import AddCommentTracker from "./AddCommentTracker";
import { actionCategories, actionContacts, actionDecisionVsOperational, actionPriority, actionResponsible, actionSource, actionStatus } from "helpers/actionTrackerOptions";
import Select from "react-select";
import ActionTrackerCommentList from "./ActionTrackerCommentList";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";
import { useLazyGetUserInfoQuery } from "store/slices/apis/authSlice";
import EditPendingApproval from "./editPendingApproval";
import { useGetAllProjectActionPendingApprovalQuery } from "store/slices/apis/projectActionDateChangeSlice";
import PendingApproval from "./pendingApproval";


const CustomTabs = ({ tabValue, handleTabChange, tabs = [] }) => {
    return (
        <Box sx={{ borderBottom: "1px solid #e0e0e0", width: "100%" }}>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
            >
                {tabs.map((tab, index) => (
                    <Tab key={index} label={tab} />
                ))}
            </Tabs>
        </Box>
    );
};

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};


const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);
const EditActionTracker = (props) => {
    const { open, handleClose, rowData, actionContact, mainTabValue, tabLength } = props;
    const [tabValue, setTabValue] = useState(0);
    const [isEditPendingApproval, setIsEditPendingApproval] = useState(false);
    const isReturnedCorrection = rowData?.status?.toLowerCase() === "returned for corrections";

    // console.log(rowData);

    const alltabs = [
        isReturnedCorrection ? "Correct & Resubmit" : "Edit Action Tracker",
        "Due Date Change Request",
    ];
   
    const tabs = mainTabValue === tabLength ? alltabs : [alltabs[0]];

    const { projectId: paramProjectId } = useParams();
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const dispatch = useDispatch();
    const projectType = localStorage.getItem("projectType") || "";
    const module = "ActionTracker";
    const [editActionTrackerResFun, editActionTrackerRes] = useEditActionTrackerMutation();
    const reqBody = {
        projectId: paramProjectId,
        projectActionId: rowData.projectActionId,
        status: "Pending"
    }

    const { data: pendingApprovalData, isLoading:loading, isError } = useGetAllProjectActionPendingApprovalQuery(reqBody)

    const { data, error, isLoading, isFetching: isProjectFething, refetch } = useGetAllProjectsQuery(projectType);
    const projectData = data?.data || [];
    const projectOptions = (projectData || []).map(p => ({
        value: p?.projectId,
        label: p?.projectName,
        projectType: p?.projectType, // optional, if you want it later
    }));

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        setIsEditPendingApproval(prev => !prev)
    };

    const handleEditPendingApproval = () => {
        setIsEditPendingApproval(prev => !prev)
        setTabValue(0)
    }


    const [trigger, { data: userInfo, isFetching }] = useLazyGetUserInfoQuery();

    useEffect(() => {
        trigger()
    }, [])


    const effectiveProjectId = paramProjectId || rowData?.projectId;

    const { data: actionSubProjectRes } = useGetMasterDataQuery(
        {
            module: module,
            category: 'SubProject',
            ProjectId: effectiveProjectId,
        },
        {
            skip: !effectiveProjectId
        }
    );

    const subProjectData = actionSubProjectRes?.data || [];
    const actionSubProjects = mapAndSortAlphabetically(subProjectData);
    const hasSubProjects = actionSubProjects?.length > 0;

    const { data: actionCategoriesRes } = useGetMasterDataQuery({ module: module, category: 'Category', ProjectId: paramProjectId });

    const categoryData = actionCategoriesRes?.data || [];
    const actionCategories = mapAndSortAlphabetically(categoryData);
    // const actionCategories = (categoryData || []).map(p => ({
    //     value: p?.value,
    //     label: p?.value,
    // }));

    const { data: actionSourceRes } = useGetMasterDataQuery({ module: module, category: 'Source', ProjectId: paramProjectId });

    const actionSourceData = actionSourceRes?.data || [];
    const actionSource = mapAndSortAlphabetically(actionSourceData);
    // const actionSource = (actionSourceData || []).map(p => ({
    //     value: p?.value,
    //     label: p?.value,
    // }));

    const { data: actionResponsibleRes } = useGetMasterDataQuery({ module: module, category: 'Owner', ProjectId: paramProjectId });

    const actionResponsibleData = actionResponsibleRes?.data || [];
    const actionResponsible = mapAndSortAlphabetically(actionResponsibleData);
    // const actionResponsible = (actionResponsibleData || []).map(p => ({
    //     value: p?.value,
    //     label: p?.value,
    // }));

    const { data: actionPriorityRes } = useGetMasterDataQuery({ module: module, category: 'Priority', ProjectId: paramProjectId });

    const actionPriorityData = actionPriorityRes?.data || [];
    const actionPriority = (actionPriorityData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: actionStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: paramProjectId });

    const actionStatusData = actionStatusRes?.data || [];
    const actionStatus = (actionStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: actionDecisionVsOperationalRes } = useGetMasterDataQuery({ module: module, category: 'DecisionVsOperational' });

    const actionDecisionVsOperationalData = actionDecisionVsOperationalRes?.data || [];
    const actionDecisionVsOperational = (actionDecisionVsOperationalData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const [formData, setFormData] = useState({
        subProject: rowData?.subProject,
        topic: rowData?.topic,
        decisionVsOperational: rowData?.decisionVsOperational,
        source: rowData?.source,
        responsible: rowData?.responsible,
        assignedTo: rowData?.assignedTo,
        // date_created: "",
        dueDate: moment(rowData?.dueDate)?.format("YYYY-MM-DD"),
        priority: rowData?.priority,
        status: rowData?.status,
        revisedDueDate: rowData?.revisedDueDate ? moment(rowData?.revisedDueDate)?.format("YYYY-MM-DD") : null,
        closedDate: rowData?.closedDate ? moment(rowData?.closedDate)?.format("YYYY-MM-DD") : null,
        comment: rowData?.comment,
        description: rowData?.description,
        projectId: rowData?.projectId,
        isCritical: rowData?.isCritical,
        // criticality: 'string'
    });

    const validationSchema = Yup.object({
        topic: Yup.string().required("Category field is required"),
        decisionVsOperational: Yup.string().required("Decision Vs Operational field is required"),
        source: Yup.string().required("Source field is required"),
        responsible: Yup.string().required("Responsible Owner field is required"),
        assignedTo: Yup.string().required("Assigned To field is required"),
        // date_created: Yup.date().required("Date Created field is required"),
        dueDate: Yup.date().required("Due Date field is required"),
        priority: Yup.string().required("priority field is required"),
        status: Yup.string().required("Status field is required"),
        // revisedDueDate: Yup.date().required("Revised Due Date  field is required"),
        // comment: Yup.string().required("Comment field is required"),
        description: Yup.string().required("Description field is required"),

        closedDate: Yup.string().when("status", {
            is: "Closed",
            then: (schema) =>
                schema.required("Closed Date is required"),
            otherwise: (schema) =>
                schema.notRequired(),
        }),
    });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {

        let revisedDueDate = null, dueDate = "", closedDate = null;

        if (values?.revisedDueDate) {
            revisedDueDate = moment
                .utc(values?.revisedDueDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        if (values?.dueDate) {
            dueDate = moment
                .utc(values?.dueDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        if (values?.closedDate) {
            closedDate = moment
                .utc(values?.closedDate, 'YYYY-MM-DD')
                .format('YYYY-MM-DDTHH:mm:ss[Z]');
        }

        let modifiyValues = {
            ...values, dueDate, revisedDueDate, closedDate, projectActionId: rowData?.projectActionId
        }

        // let modifiyValues = {
        //     ...values, projectActionId: rowData?.projectActionId, dueDate: moment(values?.dueDate)?.toISOString(), revisedDueDate: moment(values?.revisedDueDate)?.toISOString()
        // }
        editActionTrackerResFun(modifiyValues);
    };

    React.useEffect(() => {
        if (editActionTrackerRes?.isSuccess) {
            if (editActionTrackerRes?.data?.status?.toLowerCase() == 'success') {
                openNotification(editActionTrackerRes?.data?.message, 'success')
                handleClose();
            } else {
                openNotification(editActionTrackerRes?.data?.message, 'error')
            }
        }
    }, [editActionTrackerRes?.isSuccess]);


    React.useEffect(() => {
        if (editActionTrackerRes?.isError) {
            if (editActionTrackerRes?.error?.data?.status?.toLowerCase() == 'fail') {
                openNotification(editActionTrackerRes?.error?.data?.message, 'error')
            } else {
                openNotification(editActionTrackerRes?.error?.data?.message ?? 'Something went wrong!', 'error')
            }
            // cancel();
        }
    }, [editActionTrackerRes?.isError]);

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const subProjectGridSize = paramProjectId ? { xs: 12, md: 12 } : { xs: 12, md: 6 };

    return (
        <Dialog open={open}
            fullScreen
            PaperProps={{
                sx: { borderTopLeftRadius: "3px", borderTopRightRadius: "3px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#FFFFFF",
                pb: 2,
                pt: 2,
                width: "100%",
            }}><Typography sx={{ fontWeight: 600, fontSize: "18px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {isReturnedCorrection ? "Correct & Resubmit Action Tracker" : "Edit Action Tracker"}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <CustomTabs tabs={tabs} handleTabChange={handleTabChange} tabValue={tabValue} />
                    </Grid>
                    {tabValue === 0 &&
                        <>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Formik
                                    initialValues={formData}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                    enableReinitialize
                                >
                                    {({ values,
                                        errors,
                                        touched,
                                        handleChange,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        setFieldValue,
                                        setTouched, setFieldTouched }) => (
                                        <form onSubmit={handleSubmit}>
                                            <Grid container spacing={2}>
                                                <Grid size={{ xs: 12, md: 12 }}>
                                                    <Box sx={{ width: '25%' }}>
                                                        <FormGroup>
                                                            <FormControlLabel
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        fontWeight: 500,
                                                                        fontSize: "16px",
                                                                        lineHeight: "100%",
                                                                        color: "#5F5F5F",
                                                                        fontFamily: "Outfit, sans-serif",
                                                                    }
                                                                }}
                                                                control={
                                                                    <Checkbox checked={values?.isCritical}
                                                                        onChange={(e) => {
                                                                            // console.log(e.target.checked);
                                                                            setFieldValue("isCritical", e.target.checked);
                                                                        }}
                                                                    />} label="Mark as critical" />
                                                        </FormGroup>
                                                    </Box>
                                                </Grid>
                                                {paramProjectId == undefined &&
                                                    <Grid size={{ xs: 12, md: 12 }}>
                                                        <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                            Project
                                                        </Typography>
                                                        <Select
                                                            name="projects"
                                                            options={projectOptions}
                                                            value={projectOptions.find(opt => opt?.value === values?.projectId) || null}
                                                            onChange={(option) => {
                                                                setFieldValue("projectId", option?.value);
                                                                setSelectedProjectId(option?.value);
                                                            }}
                                                            onBlur={() => setFieldTouched("projectId", true)}
                                                            placeholder="Select Project"
                                                            isDisabled={true}
                                                        />
                                                        {touched?.projectId && errors?.projectId && (
                                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                                                {errors?.projectId}
                                                            </Typography>
                                                        )}
                                                    </Grid>
                                                }

                                                {hasSubProjects && (
                                                    <Grid size={subProjectGridSize}>
                                                        <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                            Select Sub Project
                                                        </Typography>
                                                        <Select
                                                            name="subProject"
                                                            options={actionSubProjects}
                                                            value={actionSubProjects.find(opt => opt.value === values.subProject) || null}
                                                            onChange={(option) => setFieldValue("subProject", option.value)}
                                                            onBlur={() => setFieldTouched("subProject", true)}
                                                            placeholder="Select Sub Project"
                                                        />
                                                        {touched.subProject && errors.subProject && (
                                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                                                {errors.subProject}
                                                            </Typography>
                                                        )}
                                                    </Grid>
                                                )}

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Select Category
                                                    </Typography>
                                                    <Select
                                                        name="topic"
                                                        options={actionCategories}
                                                        value={actionCategories.find(opt => opt.value?.toLocaleLowerCase() === values.topic?.trim()?.toLocaleLowerCase()) || null}
                                                        onChange={(option) => setFieldValue("topic", option.value)}
                                                        onBlur={() => setFieldTouched("topic", true)}
                                                        placeholder="Select Category"
                                                    />
                                                    {touched.topic && errors.topic && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.topic}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Select Decision Vs Operational
                                                    </Typography>
                                                    <Select
                                                        name="decisionVsOperational"
                                                        options={actionDecisionVsOperational}
                                                        value={actionDecisionVsOperational.find(opt => opt.value?.toLocaleLowerCase() === values.decisionVsOperational?.trim()?.toLocaleLowerCase()) || null}
                                                        onChange={(option) => setFieldValue("decisionVsOperational", option.value)}
                                                        onBlur={() => setFieldTouched("decisionVsOperational", true)}
                                                        placeholder="Select Decision Vs Operational"
                                                    />
                                                    {touched.decisionVsOperational && errors.decisionVsOperational && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.decisionVsOperational}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Select Source
                                                    </Typography>
                                                    <Select
                                                        name="source"
                                                        options={actionSource}
                                                        value={actionSource.find(opt => opt.value?.toLocaleLowerCase() == values?.source?.trim()?.toLocaleLowerCase()) || null}
                                                        onChange={(option) => setFieldValue("source", option.value)}
                                                        onBlur={() => setFieldTouched("source", true)}
                                                        placeholder="Select Source"
                                                    />
                                                    {touched.source && errors.source && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.source}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Select Responsible / Owner
                                                    </Typography>
                                                    <Select
                                                        name="responsible"
                                                        options={actionResponsible}
                                                        value={actionResponsible.find(opt => opt.value?.toLocaleLowerCase() == values.responsible?.trim()?.toLocaleLowerCase()) || null}
                                                        onChange={(option) => setFieldValue("responsible", option.value)}
                                                        onBlur={() => setFieldTouched("responsible", true)}
                                                        placeholder="Select Responsible / Owner"
                                                    />
                                                    {touched.responsible && errors.responsible && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.responsible}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Assigned To</Typography>
                                                    <Select
                                                        name="assignedTo"
                                                        isMulti
                                                        options={actionContact}
                                                        value={
                                                            values.assignedTo
                                                                ? values?.assignedTo?.split(",").map(v => actionContact?.find(opt => opt?.value?.toLocaleLowerCase() === v?.toLocaleLowerCase())).filter(Boolean)
                                                                : []
                                                        }
                                                        onChange={(selectedOptions) => {
                                                            const labels = selectedOptions.map(opt => opt?.value).join(",");
                                                            setFieldValue("assignedTo", labels);
                                                        }}

                                                        onBlur={() => setFieldTouched("assignedTo", true)}
                                                        placeholder="Select Assigned To"
                                                    />
                                                    {touched.assignedTo && errors.assignedTo && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.assignedTo}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                        Due Date
                                                    </Typography>
                                                    <TextField
                                                        type="date"
                                                        name="dueDate"
                                                        value={values.dueDate}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={(e) => {
                                                            const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                            if (input && !input.readOnly) {
                                                                if (input) input.showPicker?.();
                                                            }
                                                        }}
                                                        fullWidth
                                                        sx={{
                                                            ...rightTextStyle,
                                                            "& input::-webkit-calendar-picker-indicator": {
                                                                display: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& input[type='date']": {
                                                                appearance: "none",
                                                                WebkitAppearance: "none",
                                                            },
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    border: "none",
                                                                },
                                                            },
                                                        }}
                                                        InputProps={{
                                                            readOnly: !isReturnedCorrection,
                                                            startAdornment: (
                                                                <Box
                                                                    sx={{
                                                                        ml: 2,
                                                                        mr: 1,
                                                                        color: "#433F5E",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        cursor: "pointer",
                                                                    }}
                                                                >
                                                                    {calenderSVG}
                                                                </Box>
                                                            ),
                                                            sx: {
                                                                backgroundColor: isReturnedCorrection ? "#fff" : "#f5f5f5",
                                                                height: "40px",
                                                                border: "1px solid",
                                                                borderColor: "hsl(0, 0%, 80%)",
                                                                width: { xs: "100%", md: "100%" },
                                                                borderRadius: "3px",
                                                                cursor: "pointer",
                                                                pointerEvents: "auto",
                                                            },
                                                        }}
                                                    />

                                                    {touched.dueDate && errors.dueDate && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.dueDate}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                {/* <Grid size={{ xs: 12, md: 6 }}>
                                            <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                Revised Due Date
                                            </Typography>
                                            <TextField
                                                type="date"
                                                name="revisedDueDate"
                                                value={values.revisedDueDate}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                onClick={(e) => {
                                                    // Trigger the native date picker
                                                    const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                    if (input) input.showPicker?.();
                                                }}
                                                fullWidth
                                                sx={{
                                                    ...rightTextStyle,
                                                    "& input::-webkit-calendar-picker-indicator": {
                                                        display: "none",
                                                        WebkitAppearance: "none",
                                                    },
                                                    "& input[type='date']": {
                                                        appearance: "none",
                                                        WebkitAppearance: "none",
                                                    },
                                                    "& .MuiOutlinedInput-root": {
                                                        "& fieldset": {
                                                            border: "none",
                                                        },
                                                    },
                                                }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                        >
                                                            {calenderSVG}
                                                        </Box>
                                                    ),
                                                    sx: {
                                                        backgroundColor: "#fff",
                                                        height: "40px",
                                                        border: '1px solid',
                                                        borderColor: 'hsl(0, 0%, 80%)',
                                                        width: { xs: "100%", md: "100%" },
                                                        borderRadius: "3px",
                                                    },
                                                }}
                                            />
                                        </Grid> */}
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Select Priority
                                                    </Typography>
                                                    <Select
                                                        name="priority"
                                                        options={actionPriority}
                                                        value={actionPriority.find(opt => opt.value === values.priority) || null}
                                                        onChange={(option) => setFieldValue("priority", option.value)}
                                                        onBlur={() => setFieldTouched("priority", true)}
                                                        placeholder="Select Priority"
                                                    />
                                                    {touched.priority && errors.priority && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.priority}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: values.status === "Closed" ? 6 : 12 }}>
                                                    <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                        Select Status
                                                    </Typography>
                                                    <Select
                                                        name="status"
                                                        options={actionStatus}
                                                        value={actionStatus.find(opt => opt.value === values.status) || null}
                                                        onChange={(option) => {
                                                            setFieldValue("status", option.value);

                                                            if (option.value !== "Closed") {
                                                                setFieldValue("closedDate", "");
                                                            }
                                                        }}
                                                        onBlur={() => setFieldTouched("status", true)}
                                                        placeholder="Select Status"
                                                    />
                                                    {touched.status && errors.status && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.status}
                                                        </Typography>
                                                    )}
                                                </Grid>

                                                {values.status === "Closed" && (
                                                    <Grid size={{ xs: 12, md: 6 }}>
                                                        <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                            Closed Date
                                                        </Typography>
                                                        <TextField
                                                            type="date"
                                                            name="closedDate"
                                                            value={values.closedDate}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            onClick={(e) => {
                                                                // Trigger the native date picker
                                                                const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                if (input) input.showPicker?.();
                                                            }}
                                                            fullWidth
                                                            sx={{
                                                                ...rightTextStyle,
                                                                "& input::-webkit-calendar-picker-indicator": {
                                                                    display: "none",
                                                                    WebkitAppearance: "none",
                                                                },
                                                                "& input[type='date']": {
                                                                    appearance: "none",
                                                                    WebkitAppearance: "none",
                                                                },
                                                                "& .MuiOutlinedInput-root": {
                                                                    "& fieldset": {
                                                                        border: "none",
                                                                    },
                                                                },
                                                            }}
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                    >
                                                                        {calenderSVG}
                                                                    </Box>
                                                                ),
                                                                sx: {
                                                                    backgroundColor: "#fff",
                                                                    border: '1px solid',
                                                                    borderColor: 'hsl(0, 0%, 80%)',
                                                                    height: "40px",
                                                                    width: { xs: "100%", md: "100%" },
                                                                    borderRadius: "3px",
                                                                },
                                                            }}
                                                        />
                                                        {touched.closedDate && errors.closedDate && (
                                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5, fontFamily: "Outfit, sans-serif" }}>
                                                                {errors.closedDate}
                                                            </Typography>
                                                        )}
                                                    </Grid>
                                                )}

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Description</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="description"
                                                        value={values.description}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        multiline
                                                        rows={3}
                                                        placeholder="Enter Description"
                                                        InputProps={{
                                                            sx: {
                                                                // height: "50px",
                                                                borderRadius: "3px",
                                                                backgroundColor: "#fff",

                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },

                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {touched.description && errors.description && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.description}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelTextStyle}>Comment/ Identified Challenges/ Problems</Typography>
                                                    <TextField
                                                        fullWidth
                                                        name="comment"
                                                        value={values.comment}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        multiline
                                                        rows={3}
                                                        placeholder="Enter Comment/ Identified Challenges/ Problems"
                                                        InputProps={{
                                                            sx: {
                                                                // height: "50px",
                                                                borderRadius: "3px",
                                                                backgroundColor: "#fff",

                                                                "& input::placeholder": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                    opacity: 1,
                                                                },

                                                                "& input": {
                                                                    fontWeight: 400,
                                                                    fontSize: "16px",
                                                                    lineHeight: "100%",
                                                                    letterSpacing: "0.16px",
                                                                    color: "#0A0A0C",
                                                                    fontFamily: "Outfit, sans-serif",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={12}>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "flex-end",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <Button onClick={handleClose}
                                                            sx={{
                                                                textTransform: "none",
                                                                color: "#F15744",
                                                                fontSize: "14px",
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                borderRadius: "3px",
                                                                fontWeight: 500,
                                                                px: "20px",
                                                                py: "15px",
                                                            }}>
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            type="submit"
                                                            variant="contained"
                                                            loading={editActionTrackerRes?.isLoading}
                                                            sx={{
                                                                backgroundColor: "#00344C",
                                                                borderRadius: "3px",
                                                                textTransform: "none",
                                                                fontWeight: 500,
                                                                fontSize: "14px",
                                                                lineHeight: "100%",
                                                                fontFamily: "Outfit, sans-serif",
                                                                color: "#FFFFFF",
                                                                px: "20px",
                                                                py: "15px",
                                                            }}
                                                        >
                                                            {isReturnedCorrection ? "Correct & Resubmit" : "Save"}
                                                        </Button>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    )}
                                </Formik>
                            </Grid>
                            <Grid
                                size={{ md: 6, xs: 12 }}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: '90vh', // adjustable
                                    border: "1px solid #e0e0e0",
                                    borderRadius: "3px",
                                    overflow: "auto",
                                }}
                            >
                                <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>
                                    {/* Comment list */}
                                    <ActionTrackerCommentList data={rowData} />
                                </Box>

                                <Box sx={{ borderTop: "1px solid #e0e0e0", p: 2 }}>
                                    <AddCommentTracker data={rowData} />
                                </Box>
                            </Grid>
                        </>
                    }
                    {tabValue === 1 &&
                        <PendingApproval  data = {rowData}/>
                        // <Grid size={{ md: 12, xs: 12 }}>
                        //     <EditPendingApproval open={isEditPendingApproval} handleClose={handleEditPendingApproval} rowData={pendingApprovalData?.data || []} />
                        // </Grid>
                    }
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EditActionTracker;
